// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetLocationsRequestModel from '../../model/get-locations-request-model';
import GetLocationsRequestDTO from '../dto/get-locations-request-dto';

export default abstract class GetLocationsRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetLocationsRequestDTO>) {
    super();
    if (data) {
      this.postalCodeCriteria = data.postalCodeCriteria;
      this.searchCriteria = data.searchCriteria;
      this['paging.CurrentPage'] = data['paging.CurrentPage'];
      this['paging.PageSize'] = data['paging.PageSize'];
      this['paging.IncludeCount'] = data['paging.IncludeCount'];
      this['paging.NoPaging'] = data['paging.NoPaging'];
    }
  }
  /**
  */
  'postalCodeCriteria'?: string;
  /**
  */
  'searchCriteria'?: string;
  /**
  * @type {int32}
  */
  'paging.CurrentPage'?: number;
  /**
  * @type {int32}
  */
  'paging.PageSize'?: number;
  /**
  */
  'paging.IncludeCount'?: boolean;
  /**
  */
  'paging.NoPaging'?: boolean;

  static toModel(dto: DeepPartial<GetLocationsRequestDTO>): GetLocationsRequestModel;
  static toModel(dto: DeepPartial<GetLocationsRequestDTO> | undefined | null): GetLocationsRequestModel | undefined;
  static toModel(dto: DeepPartial<GetLocationsRequestDTO> | undefined | null): GetLocationsRequestModel | undefined {
    return dto ? new GetLocationsRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetLocationsRequestModel> | GetLocationsRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'postalCodeCriteria': unwrapped.postalCodeCriteria,
      'searchCriteria': unwrapped.searchCriteria,
      'paging.CurrentPage': unwrapped['paging.CurrentPage'],
      'paging.PageSize': unwrapped['paging.PageSize'],
      'paging.IncludeCount': unwrapped['paging.IncludeCount'],
      'paging.NoPaging': unwrapped['paging.NoPaging'],
    } as GetLocationsRequestDTO;
  }
}
